import { IDtnAuthorization } from "@/shared/dtnWeather";

import { IState } from "../state";

export class DtnWeather {
  static setDtnAuthorization(state: IState, dtnAuthorization: IDtnAuthorization) {
    const newState = Object.assign({}, state);

    newState.dtnAuthorization = dtnAuthorization;
    return newState;
  }
}
